import portsApi from '../framework/ports/portsApi';

export type ViewMode = 'sidebar' | 'mobile' | 'desktop';

const PromotionsFrontend = {
  startPromotions: (socketId: string, viewMode: ViewMode) => {
    return portsApi.invoke('Promotions.startPromotions', [socketId, viewMode]);
  },
  stopPromotions: () => portsApi.invoke('Promotions.stopPromotions'),
  showPromotionsList: (locale: string) => {
    return portsApi.invoke('Promotions.showPromotionsList', [locale]);
  },
  showPromotionsDetails: (slug: string, locale: string) => {
    return portsApi.invoke('Promotions.showPromotionsDetails', [slug, locale]);
  },
};

export default PromotionsFrontend;
